import { DialogRef } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { WatchVideoService } from "src/app/services/watch-video-service/watch-video.service";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-start-video",
  imports: [SharedModule, CommonModule],
  templateUrl: "./start-video.component.html",
  styleUrl: "./start-video.component.scss",
})
export class StartVideoDialogComponent {
  #dialogRef = inject(MatDialogRef<boolean>);
  #watchVideoService = inject(WatchVideoService);
  videoLoading = this.#watchVideoService.videoLoading;

  onClose(value?: boolean) {
    this.#dialogRef.close(value!);
  }

  getStarted() {
    this.onClose(true);
  }
}
